import React, { useState } from "react";
import ProductIcon from "../../../../../images/common/product.svg";
import ServiceIcon from "../../../../../images/common/service.svg";
import MembershipIcon from "../../../../../images/common/ball-trio.svg";
import DonationIcon from "../../../../../images/donation/donating-hands.svg";
import BundleIcon from "../../../../../images/common/bundle.svg";
import { NavigateFunction } from "react-router-dom";
import {
  BubbleWrapper,
  CustomLabel,
  FlexContainer,
  PlaceholderWrapper,
  SapphireBlueButton,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { GridNames } from "../enums";
// import CartIcon from '../../../../../images/common/cart-blue.svg';
// import SubscriptionIcon from '../../../../../images/membership/recurring.svg';
// import InvoiceIcon from '../../../../../images/common/invoice-blue.svg';
// import PaymentIcon from '../../../../../images/membership/dollar-blue.svg';
// import PaymentMethodIcon from '../../../../../images/payment/bank-ach-icon.svg';
// import { SapphireBlueButton } from '../styles/Button';

interface Item {
  icon: string;
  title: string;
  description: React.ReactNode;
  className?: string;
}

export interface CustomPlaceholdersProps {
  image?: string;
  label?: string | React.ReactNode;
  description?: React.ReactNode;
  showItems?: boolean;
  height?: string;
  navigate: NavigateFunction;
  showButton?: boolean;
  customButton?: boolean;
  gridName?: keyof typeof GridNames;
  className?: string;
  onOpenPopUp?: (popupName: string) => void;
}

const items: Item[] = [
  {
    icon: ProductIcon,
    title: "Product",
    description: (
      <>
        Product is a physical good that can be delivered, installed, or shipped.
        It can have different versions or “variants” with custom attributes like
        color, size, style, flavor, and more. Variants can have custom pricing,
        inventory levels, images, videos, descriptions, and more.
        <div className="two-line-breaks">
          Product pricing is very flexible. Create a standard unit price for
          your Product, or offer incentives with package, volume, and tiered
          pricing based on quantity. Even allow your customer to choose what
          they pay.
        </div>
      </>
    ),
    className: "product-bubble",
  },
  {
    icon: ServiceIcon,
    title: "Service",
    description: (
      <>
        Service can be used to charge for consulting hours, marketing services,
        delivery, installation, repair, web hosting, design work, a warranty...
        really anything that is a non-physical product.
        <div className="two-line-breaks">
          Service pricing is flexible and supports standard, package, volume,
          tiered and custom pricing. Create multiple pricing plans, each with
          term or recurring billing. For recurring, you can select cancellation
          terms, renewal fees and renewal increases.
        </div>
      </>
    ),
    className: "service-bubble",
  },
  {
    icon: MembershipIcon,
    title: "Membership",
    description: (
      <>
        Memberships are like Services, but have more billing flexibility and can
        support Programs and Levels. Although Memberships can end, they more
        commonly continue on a recurring basis until cancelled like a sports,
        fitness or e-learning subscription.
        <div className="two-line-breaks">
          Membership pricing allows for multiple pricing plans. Volume based
          pricing is not available, but you can setup term, recurring, or term
          and recurring billing. For recurring, you can select cancellation
          terms, renewal fees and renewal increases.
        </div>
      </>
    ),
    className: "membership-bubble",
  },
  {
    icon: DonationIcon,
    title: "Donation",
    description: (
      <>
        Donations are used to collect money for a fundraising drive or cause.
        They have many powerful and flexible options to drive increased
        donations. These include set and custom donation amounts, one time or
        monthly donations, beneficiaries, in memory of and more.
        <div className="two-line-breaks">
          The donor can choose to automatically increase their donation each
          year and even cover the cost to cover the merchant processing cost.
        </div>
      </>
    ),
    className: "donation-bubble",
  },
  // {
  //   icon: BundleIcon,
  //   title: "Bundle",
  //   description: (
  //     <>
  //       Bundles allow you to group other Item types together like Products,
  //       Services & Memberships and sell as a package. You set a single price for
  //       your bundle and can offer a discount as an incentive.
  //       <div className="two-line-breaks">
  //         You can combine Items with different billing options like term and
  //         recurring in the same bundle.
  //       </div>
  //     </>
  //   ),
  //   className: "bundle-bubble",
  // },
];

const CustomPlaceholders: React.FC<CustomPlaceholdersProps> = (props) => {
  const {
    image,
    label,
    description,
    showItems = false,
    height,
    showButton = false,
    customButton = false,
    gridName,
    className,
    onOpenPopUp,
  } = props;
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const [activePopup, setActivePopup] = useState<string | null>(null);

  function onItemClick(item: string) {
    switch (item) {
      case "Product":
        props.navigate("/app/product/detail");
        break;
      case "Service":
        props.navigate("/app/service/detail");
        break;
      case "Membership":
        props.navigate("/app/membership/detail");
        break;
      case "Donation":
        props.navigate("/app/donation/detail");
        break;
    }
  }

  const renderItem = (
    icon: string,
    label: string,
    description: React.ReactNode,
    className?: string
  ) => (
    <div
      onMouseEnter={() => setActiveItem(label)}
      onMouseLeave={() => setActiveItem(null)}
      // onClick={() => setActiveItem(activeItem === label ? null : label)}
      onClick={() => onItemClick(label)}
    >
      <div className={`opaque ${activeItem === label ? "active" : ""}`}>
        <img src={icon} alt={`${label} Icon`} />
        <CustomLabel>{label}</CustomLabel>
      </div>
      {activeItem === label && (
        <BubbleWrapper className={className}>{description}</BubbleWrapper>
      )}
    </div>
  );

  // function renderPopup() {
  //   switch (activePopup) {
  //     case "payment":
  //       return (
  //         <UpsertPaymentPopUp
  //           onClose={(refresh: boolean) => onClose(refresh)}
  //           paymentData={new UpsertPaymentModel()}
  //         />
  //       );
  //     case "subscription":
  //       return (
  //         <NewSubscriptionPopUp
  //           subscriptionData={new SubscriptionModel()}
  //           onClose={(refresh: boolean) => onClose(refresh)}
  //         />
  //       );
  //     case "invoice":
  //       return (
  //         <UpsertInvoicePopUp
  //           onClose={(refresh: boolean) => onClose(refresh)}
  //           invoiceData={new UpsertInvoiceModel()}
  //         />
  //       );
  //     case "contact":
  //       return (
  //         <NewContactPopup onClose={(refresh: boolean) => onClose(refresh)} />
  //       );
  //     default:
  //       return null;
  //   }
  // }

  const onClickButton = () => {
    switch (gridName) {
      case GridNames.Payment:
        onOpenPopUp && onOpenPopUp("payment");
        break;
      case GridNames.Subscription:
        onOpenPopUp && onOpenPopUp("subscription");
        break;
      case GridNames.Invoice:
        onOpenPopUp && onOpenPopUp("invoice");
        break;
      case GridNames.Contact:
        onOpenPopUp && onOpenPopUp("contact");
        break;
      case GridNames.Checkout:
        props.navigate("/app/checkout/detail");
        break;
      case GridNames.Donation:
        props.navigate("/app/donation/detail");
        break;
      default:
        break;
    }
  };

  // const onClose = (refresh: boolean) => {
  //   setActivePopup(null);
  //   if (refresh) {
  //     window.location.reload();
  //   }
  // };
  return (
    <>
      {/* {renderPopup()} */}
      <PlaceholderWrapper height={height} className={className}>
        <FlexContainer className="plh-main-section">
          <img
            src={image}
            alt="icon"
            className={`plh-main-icon ${showItems ? "plh-icon-margin" : ""}`}
          />
          {label && <CustomLabel className="plh-label">{label}</CustomLabel>}
          {description && (
            <CustomLabel className="plh-description">{description}</CustomLabel>
          )}
          {/* {showItems && (
            <div>
              <FlexContainer
                className={`plh-sub-section ${activeItem ? "bubble-height" : ""}`}
              >
                {items.map((item) =>
                  renderItem(
                    item.icon,
                    item.title,
                    item.description,
                    item.className
                  )
                )}
              </FlexContainer>
            </div>
          )} */}
          {showButton &&
            !showItems &&
            gridName !== GridNames.Order &&
            gridName !== GridNames.Donation &&
            gridName !== GridNames.Donors &&
            gridName !== GridNames.PayOuts && (
              <SapphireBlueButton
                primary
                className="plh-btn"
                onClick={() => onClickButton()}
              >
                New {gridName ? gridName : "Item"}
              </SapphireBlueButton>
            )}
          {customButton && customButton}
        </FlexContainer>
      </PlaceholderWrapper>
    </>
  );
};

export default withRouter(CustomPlaceholders);
